import Icon from '../components/Icon';

const Weather3 = Icon(
  'weather-3',
  <>
    <path
      fillRule="evenodd"
      d="M9.364 1.25c-2.867 0-5.298 1.95-5.858 4.594C2.193 6.39 1.25 7.65 1.25 9.15c0 2.019 1.702 3.599 3.73 3.599h9.087c2.554 0 4.683-1.989 4.683-4.512 0-2.45-2.01-4.398-4.467-4.506-1.082-1.505-2.887-2.482-4.92-2.482M4.916 6.5c.257-2.086 2.127-3.75 4.448-3.75 1.666 0 3.107.862 3.877 2.122.143.233.4.37.673.358q.075-.003.152-.003c1.79 0 3.184 1.38 3.184 3.011s-1.393 3.012-3.184 3.012H4.98c-1.263 0-2.229-.971-2.229-2.1 0-.937.662-1.761 1.616-2.018a.75.75 0 0 0 .55-.632"
      clipRule="evenodd"
    />
    <path d="M1.75 15a.75.75 0 0 1 .75-.75h16.75a3 3 0 0 1 0 6c-1.257 0-2.518-.815-2.953-1.99a.75.75 0 1 1 1.406-.52c.2.54.867 1.01 1.547 1.01a1.5 1.5 0 1 0 0-3H2.5a.75.75 0 0 1-.75-.75" />
    <path d="M1.75 18a.75.75 0 0 1 .75-.75h9a3 3 0 0 1 0 6c-1.257 0-2.518-.815-2.953-1.99a.75.75 0 0 1 1.406-.52c.2.54.867 1.01 1.547 1.01a1.5 1.5 0 1 0 0-3h-9a.75.75 0 0 1-.75-.75" />
  </>
);

export default Weather3;
